import React from 'react';
import '../styles/loading.css';

function Loading() {
  return (
    <div id='loading-overlay'>
        <div id='spinner'></div>
    </div>
  )
}

export default Loading